
import React, { useEffect, useMemo, useState, Suspense, lazy } from 'react';
import { commonGet } from '../../../services/CommonService';


const ViewEducation =({user}) =>{

    const[educations,setEducation] = useState([]);

    useEffect(() => {

        console.log(user);
        getEducation();

    }, []);

    const getEducation =async() =>{

        const reqparam ={
            pageno:'-1',
            ptype:'USEREDUCATION',
            query:{userid:user.id}

        }

        const EduResponse = await commonGet(reqparam);
        setEducation(EduResponse.data);
    }

    return(<>
     <div className="col-12">
      <div className="card">
        
        <div className="card-body">
          <div className="table-responsive">
            <div id="job_data" className="dataTables_wrapper">
              <table
                className="display w-100 dataTable "
                id="example5"
                role="grid"
                aria-describedby="example5_info"
              >
                <thead>
                  <tr role="row">
                    <th className="sorting_asc" style={{ width: "177px" }}>
                      Education
                    </th>
                    <th className="sorting" style={{ width: "278px" }}>
                      Course
                    </th>
                    <th className="sorting" style={{ width: "128px" }}>
                      Marks
                    </th>
                    <th className="sorting" style={{ width: "46px" }}>
                       Year
                    </th>
                     <th className="sorting" style={{ width: "110px" }}>
                      College 
                    </th>
                    <th className="sorting" style={{ width: "110px" }}>
                      District 
                    </th>
                    <th className="sorting" style={{ width: "110px" }}>
                      State 
                    </th>
                  </tr>
                </thead>

                <tbody>
                 

                  {educations.map(( listValue, index ) => {
                    return (
                      <tr key={index}>
                        <td>{listValue.education}</td>
                        <td>{listValue.course}</td>
                        <td>{listValue.marks}</td>
                        <td>{listValue.startyear}- {listValue.endyear}</td>
                        <td>{listValue.college}</td>
                        <td>{listValue.district}</td>
                        <td>{listValue.state}</td>
                      </tr>
                    );
                  })}
                 
                </tbody>
               
              </table>
              
            </div>
          </div>
        </div>
      </div>
    </div>
    </>)
}

export default ViewEducation